import React from 'react'
import { MenuOverlay, Divider } from '@fs/zion-ui'
import { getNestedOrFloatingElementById, useSlsStateContext } from '@fs/zion-sls'
import LinkedNameItem from './LinkedNameItem'

const LinkedNamesOverlay = ({ overlay, person, fact, selectHandler }) => {
  const slsState = useSlsStateContext()
  const filteredSuperElements = fact.superElements.filter((supEl) => supEl.id !== person.id)
  const elements = filteredSuperElements
    .map((supEl) => getNestedOrFloatingElementById(slsState.images, supEl.id))
    .filter(Boolean)
  const sortedElements = elements.sort((a, b) => {
    if (a.recordId !== b.recordId) {
      if (b.recordId === person.recordId) return 1
      if (a.recordId === person.recordId) return -1
      if (a.recordId > b.recordId) return 1
      if (a.recordId < b.recordId) return -1
    }
    return 0
  })
  return (
    <MenuOverlay {...overlay}>
      {sortedElements?.map((element, index) => (
        <React.Fragment key={element.id}>
          <LinkedNameItem element={element} selectHandler={selectHandler} />
          {sortedElements[index + 1] && element.recordId !== sortedElements[index + 1]?.recordId && (
            <Divider fullWidth />
          )}
        </React.Fragment>
      ))}
    </MenuOverlay>
  )
}

export default LinkedNamesOverlay
